import React, { useEffect, useState } from "react";
import { TextField } from "@material-ui/core";
import { Col } from 'reactstrap';
import FormControl from '@material-ui/core/FormControl';
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import ShowKeywords from "./ShowKeywords"
import ArchiveTab from "./ArchiveTab"
import { useTheme } from '@material-ui/core/styles'
import { muiNoOutline } from "../../../utils"
import config from "../../../config"

const CreateTabContent = ({ setVersion, version, setTags, setName, ApiOption, name, formData, setFormData
}) => {
    const saveArchive = useSelector(state => state.analyseData.saveArchive)
    const [localTags, setLocalTags] = useState(saveArchive?.tags?.join(', ') || '')
    const { t } = useTranslation()
    const { theme: { bgColors, colors } } = useTheme()
    const themeState = useSelector(state => state.userData.theme || localStorage.getItem('theme') || config.THEMES_MODES.LIGHT)
    const isContrast = themeState !== config.THEMES_MODES.LIGHT
    const classes = muiNoOutline()

    useEffect(() => {
        setTags(localTags)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [localTags])

    return (
        <Col sm="12" className={'d-flex align-items-center pr-5 pl-5'} style={{ minHeight: 200 }}>
            <FormControl className={'d-flex py-2'} style={{ gridGap: 10, color: colors.colorText }} component="fieldset">
                <br />
                <ArchiveTab type={ApiOption} formData={formData} setFormData={setFormData} />
                {<TextField value={name} style={{ width: "250px", backgroundColor: bgColors.bgColors0 }} label={t('Name')} type='text' variant='outlined' size='small' onChange={(e) => setName(e.target.value)} InputProps={{ style: { color: colors.colorText, backgroundColor: bgColors.bgPrimary200 }}} InputLabelProps={{ style: { color: colors.colorText } }} classes={isContrast ? { root: classes.root } : {}}
                />}
                <TextField style={{ width: "250px" }} onChange={(e) => setVersion(e.target.value)} label={t('Version')} type='text' variant='outlined' size='small' value={version} InputProps={{ style: { color: colors.colorText, backgroundColor: bgColors.bgPrimary200 }}} InputLabelProps={{ style: { color: colors.colorText } }} classes={isContrast ? { root: classes.root } : {}} />
                <TextField style={{ width: "250px" }} label={localTags?.length === 0 && t("Keywords")} id='keywords' type='text' variant='outlined' size='small' InputProps={{ style: { color: colors.colorText, backgroundColor: bgColors.bgPrimary200 }}} InputLabelProps={{ style: { color: colors.colorText } }} classes={isContrast ? { root: classes.root } : {}}
                    onChange={(e) => setLocalTags(e.target.value)}
                    autoComplete='off'
                    value={!!localTags ? localTags : ''}
                    placeholder={t('keywords')}
                />
                <ShowKeywords keywordsString={localTags}/>
            </FormControl>
        </Col>
    )
}

export default CreateTabContent